module.exports = "/DesktopModules/Cantarus/StencilDisplay/Clients/assets/cc_icon_preview.svg";